// /privacy: the address people guess for the privacy notice. The notice is
// the second tab of the public legal page (/legal#privacy, W4-5; D-19), so
// this only points there, for anyone, signed in or not.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/privacy')({
  beforeLoad: () => {
    throw redirect({ to: '/legal', hash: 'privacy', replace: true });
  },
});
